module.exports = __webpack_public_path__ + "img/Group-540.3a7bf04d.png";